// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"25":"f69449f3","94":"af5006bb","150":"c8ee816c","427":"c3945505","449":"048ecbdd","536":"097b726d","559":"ecfefa80","578":"a8a69114","904":"ed594d93","925":"c658cf7e"}[chunkId] + ".js";
};